import React from 'react';

//components
import Icon from  '@/components/elements/icons/Icons';
import { IconLibrary } from  '@/interfaces/IconLibrary';
import LinkStyleButton from  '@/components/elements/global/buttons/LinkStyleButton';



const NoUserGroupsPanel = ({onAddAllUserGroupsClick, onSelectGroupsClick}) => {

    return (
        <div className='no-user-groups-panel'>
            <Icon iconName={IconLibrary.USER_NONE} sizeInPx='24' color='#6A6F75'/>

            <div className='information-detail'>No user groups in workspace</div>

            <div className="action-links">
                <LinkStyleButton content={`Add 'All Organisation Users' Group`} ariaLabel={"Add all user groups from your organisation to this Workspace"} onButtonClick={onAddAllUserGroupsClick} className="action-link" />

                <span> or </span>

                <LinkStyleButton content={`Select Group(s)`} ariaLabel={"Select User Groups to add to this Workspace"} onButtonClick={onSelectGroupsClick} className="action-link" />
            </div>
        </div>
    )
}

export default NoUserGroupsPanel